// extracted by mini-css-extract-plugin
export default {"modal":"KvRbIAzqdnUyj_QqMOaw","content":"Nbrpu0GKPT36kcrgYEB6"};